import ImportExportIcon from '@material-ui/icons/ImportExport';

type Props = {
    onClick: () => void
}

const AssetPositionChangeButton = ({ onClick }: Props) => {
    return (
        <ImportExportIcon style={{ color: "white", fontSize: "2em" }} onClick={onClick} />
    );
}

export default AssetPositionChangeButton;